<template>
  <div>
    <!-- 配送區域 -->
    <div class="flex flex-wrap mb-2 lg:mb-4">
      <div class="w-full px-3 lg:flex items-center">
        <label class="lg:w-1/5 tracking-wider textColorDarkBlack text-sm font-bold" for="country">
          配送區域
        </label>
        <div class="lg:w-4/5 relative text-sm">
          <select class="block appearance-none w-full  border border-gray-500 textColorDarkBlack py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900" id="country"
            v-model="country" disabled>
            <option value="Taiwan" class="py-2">臺灣及離島</option>
          </select>
          <div class=" pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 md:px-2 textColorDarkBlack">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div>
    </div>
    <!-- 付款方式 -->
    <div class="flex flex-wrap mb-2 lg:mb-4">
      <div class="w-full px-3 lg:flex items-center">
        <label class="lg:w-1/5 tracking-wide textColorDarkBlack text-sm font-bold" for="payment">
          付款方式
        </label>
        <div class="lg:w-4/5 relative text-sm">
          <select class="block appearance-none w-full  border border-gray-500 textColorDarkBlack py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900" id="payment"
            @change="emitPayment(type)" v-model="type">
            <option value="CreditCard" class="py-2">線上刷卡付款</option>
            <option value="ATM" class="py-2" v-if="!isOnlyCredit" :class="{ hidden: isOnlyCredit }">虛擬ATM付款</option>
            <option value="COD" class="py-2" v-if="!CODisDisabled && !isOnlyCredit && !isOnlyCreditATM" :class="{ hidden: CODisDisabled || isOnlyCredit || isOnlyCreditATM }">貨到付款</option>
          </select>
          <div class=" pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 md:px-2 textColorDarkBlack">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div>
    </div>
    <!-- 運送方式 -->
    <div class="flex flex-wrap mb-4 lg:mb-4">
      <div class="w-full px-3 lg:flex items-center">
        <label class="lg:w-1/5 tracking-wider textColorDarkBlack text-sm font-bold" for="shipping">
          運送方式
        </label>
        <div class="lg:w-4/5 relative text-sm">
          <select class="block appearance-none w-full  border border-gray-500 textColorDarkBlack py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900" id="shipping"
            @change="emitPayment" v-model="shipping">
            <option value="COD">郵寄／宅配</option>
          </select>
          <div class=" pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 md:px-2 textColorDarkBlack">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethod',

  props: {
    parentType: {
      type: String,
      required: true
    },
    CODisDisabled: {
      type: Boolean,
      default: false
    },
    // 校園部活動
    isOnlyCredit: {
      type: Boolean,
      default: false
    },
    isOnlyCreditATM: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      country: 'Taiwan',
      type: 'CreditCard',
      shipping: 'COD'
    }
  },
  watch: {
    parentType: {
      immediate: true,
      handler (newVal) {
        let self = this
        if ((newVal !== self.type)) {
          self.type = self.parentType
        }
      }
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    setType (type) {
      let self = this
      self.type = type

      self.emitPayment()
    },
    emitPayment (changeType) {
      let self = this
      let arr = {
        country: self.country,
        type: changeType,
        shipping: self.shipping
      }
      self.$emit('paymentType', arr)
    }
  }
}
</script>

<style lang="scss" scoped>
  .payment-radio {
    input[type="radio"] + label .span {
      transition: .2s,
    }
    input[type="radio"] + label .span:hover,
    input[type="radio"] + label:hover .span {
      background-color: #e6e6e6;
    }
    .activeRadio {
      .span {
        background-color: #898989  !important;
        box-shadow: 0px 0px 0px 2px white inset;
      }
    }
  }
  .controls-payment-item {
    input[type="checkbox"] {
      box-sizing: border-box;
      padding: 0;
      margin-right: .4em;
      width: 100%;
      margin-bottom: 10px;
      &:hover + label:before {
        background: #e6e6e6;
      }
    }
    label {
      position: relative;
      display: inline-block;
      padding-left: 16px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      vertical-align: middle;
    }

    label:before {
      content: '';
      display: inline-block;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      width: 12px;
      height: 12px;
      border: 1px solid #6c6c6c;
      transition: .2s;
    }
    .labelisTrue:hover + label:before {
      background: #ffffff !important;
    }
    .labelisTrue + label:after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background-color: #383838;
      width: 6px;
      height: 6px;
      left: 3px;
    }
    span {
      line-height: 18px;
    }
    .digitalDiabled + label:before {
      border: 1px solid #c7c7c7 !important;
    }
  }
</style>
